// =============================================================================
// SOURCE UNIQUE — rôles plateforme assignables via les écrans admin
// =============================================================================
//
// Utilisée par RBACManager.jsx et GouvSecurity.jsx pour le sélecteur « Rôle »
// de création/édition d'un utilisateur. Les écrans NE DOIVENT PAS redéclarer
// leur propre liste : c'est cette divergence qui a causé le bug R5 —
// `regie` absent des DEUX sélecteurs et `external` présent dans un seul →
// éditer un compte régie (etincelle@omvfrance.fr) forçait un autre rôle
// (« User Externe »), cassant le cloisonnement de sécurité régie.
//
// Dérivée de l'enum backend plateforme `tenant_platform/rbac.py:Role`
// (super_admin, admin, manager, user, external) + le rôle `regie`
// (cf. metier_hub/core/models.py:RoleUtilisateur.REGIE, appliqué par
// l'allowlist deny-by-default du TenantMiddleware).
//
// Rôles métier INTERNES non listés ici volontairement (commercial, visiteur,
// direction, administratif) : ils relèvent d'affectations métier
// (visiteur/installateur sur un dossier), pas du rôle plateforme
// d'authentification. À ajouter ici uniquement s'ils doivent devenir
// assignables depuis l'admin plateforme.

export const ASSIGNABLE_ROLES = [
  { value: "super_admin", label: "Super Admin", colorClass: "text-amber-400", superAdminOnly: true },
  { value: "admin", label: "Admin", colorClass: "text-blue-400" },
  { value: "manager", label: "Manager", colorClass: "text-purple-400" },
  { value: "user", label: "Utilisateur", colorClass: "text-zinc-400" },
  { value: "external", label: "User Externe", colorClass: "text-emerald-400" },
  { value: "regie", label: "Régie", colorClass: "text-cyan-400" },
];

/**
 * Liste des rôles assignables filtrée selon les droits de l'opérateur.
 * `super_admin` reste réservé aux super-admins (gating conservé).
 *
 * @param {{ isSuperAdmin?: boolean }} opts
 * @returns {Array<{value:string,label:string,colorClass:string}>}
 */
export function assignableRolesFor({ isSuperAdmin = false } = {}) {
  return ASSIGNABLE_ROLES.filter((r) => !r.superAdminOnly || isSuperAdmin);
}
